module.exports = __webpack_public_path__ + "static/media/mario-moustache.acb58a62.svg";